import { render, staticRenderFns } from "./PPDOM_Navbar.vue?vue&type=template&id=08ba5b5a&scoped=true"
import script from "./PPDOM_Navbar.vue?vue&type=script&lang=js"
export * from "./PPDOM_Navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba5b5a",
  null
  
)

export default component.exports